const Teams = [
    {
        Id: '1',
        tImg:'/assets/images/instructors/Sarah.jpg',
        slug:'Sarah-Mitchell',
        name:'Sarah Mitchell',
        title:'Technology & Digital Skills Expert',
    },
    {
        Id: '2',
        tImg:'/assets/images/instructors/James.jpg',
        slug:'Dr-James-Cooper',
        name:'Dr. James Cooper',
        title:'Health & Wellbeing Specialist',
    },
    {
        Id: '3',
        tImg:'/assets/images/instructors/Emma.jpg',
        slug:'Emma-Thompson',
        name:'Emma Thompson',
        title:'Finance & Economy Advisor',
    },
    {
        Id: '4',
        tImg:'/assets/images/instructors/Michael.jpg',
        slug:'Michael-Roberts',
        name:'Michael Roberts',
        title:'Business & Entrepreneurship Coach',
    },
    {
        Id: '5',
        tImg:'/assets/images/instructors/david.jpg',
        slug:'David-Anderson',
        name:'David Anderson',
        title:'Transport & Logistics Specialist',
    }
]

export default Teams;